exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .avatar[data-v-9421b412]{width:40px;height:40px;border-radius:50%;vertical-align:middle;-o-object-fit:cover;object-fit:cover}table tbody td.username span.el-tag[data-v-9421b412]{float:right}.increase[data-v-9421b412]{color:#0abb87}", ""]);

// exports
